import type { ReactNode } from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { Alert } from 'antd';

import * as styles from './MAlert.styles';

export interface MAlertProps {
  type: 'success' | 'info' | 'warning' | 'error';
  description: string | ReactNode;
  closable?: boolean;
  onClick?: () => void;
  showIcon?: boolean;
  icon?: ReactNode;
  condensed?: boolean;
  className?: string;
  testId?: string;
}

export const MAlert = ({
  type,
  description,
  closable = false,
  onClick,
  showIcon = true,
  icon,
  condensed = false,
  className,
  testId,
}: MAlertProps) => {
  return (
    <Alert
      type={type}
      showIcon={showIcon}
      icon={icon ?? <ExclamationCircleOutlined className={styles.icon(type)} />}
      description={description}
      closable={closable}
      onClick={onClick}
      className={cx(styles.alert(type, condensed), className)}
      data-testid={testId}
    />
  );
};
